import trackEvent from './trackEvent'

type TSearchResultEventProps = {
  searchTermSent?: string
  searchTermTyped: string
}
const searchResultEvent = (props: TSearchResultEventProps): void => {
  trackEvent({
    event: 'searchResult',
    se_searchOrigin: 'standard',
    se_searchResult: 1,
    se_searchTermSent: props.searchTermSent || props.searchTermTyped,
    se_searchTermTyped: props.searchTermTyped,
    se_sorting: 'default',
  })
}

export default searchResultEvent
